import { IonDatetimeButton } from '@ionic/react';
import styled from 'styled-components';
import { AllieDatetimeButtonProps } from './DatetimeButton.types';

const verticalPadding = {
  normal: 18,
  medium: 16,
  small: 8,
};

export const StyledDatetimeButton: any = styled(IonDatetimeButton)`
  ::part(native) {
    padding-top: ${(props: AllieDatetimeButtonProps) =>
      verticalPadding[props.allieSize || 'small']}px;
    padding-bottom: ${(props: AllieDatetimeButtonProps) =>
      verticalPadding[props.allieSize || 'small']}px;
    padding-left: ${(props: AllieDatetimeButtonProps) =>
      props.allieSize === 'normal' ? '40' : '15'}px;
    padding-right: ${(props: AllieDatetimeButtonProps) =>
      props.allieSize === 'normal' ? '40' : '15'}px;
    background-color: var(--allie-color-neutral-5);
    border: 1px solid var(--allie-color-neutral-30);
    color: var(--allie-color-neutral-50);
  }
`;
